// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8221) return "static/chunks/8221.31945d7852181084.js";
	if (chunkId === 7400) return "static/chunks/7400.a950c2d0f0411669.js";
	if (chunkId === 167) return "static/chunks/167.3200a9b869457e0a.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 696 ? "1e87141b" : chunkId) + "-" + {"696":"87bf2fa0332c8b65","1272":"1bdb031b13af1d7e","1689":"c6fa7e586c0bca1f","2086":"f832eb2bce0c80f1","2668":"cd6ca3f87c6e1270","5703":"38d2e8f0d2419f18","8606":"6d3ba7cef4fe0bd7"}[chunkId] + ".js";
};